import React, { useState, useEffect, useRef } from 'react';
import { BsThreeDotsVertical } from "react-icons/bs";
import axios from "axios";
import { toast } from 'react-toastify';

const PTClients = () => {
  const [planType, setPlanType] = useState('All');
  const [sortOption, setSortOption] = useState('All');
  const [editingClient, setEditingClient] = useState(null);
  const [trainerName, setTrainerName] = useState('');
  const modalRef = useRef(); // Reference for the modal
  const [plan, setPlan] = useState('All');

  const [clients, setClients] = useState([]);
  const [trainers,setTrainers] = useState([]);

 

  const filteredClients = clients.filter(client =>
    (plan === 'All' || client.plan === plan) &&
    (sortOption === 'All' || (sortOption === 'Expired' && client.planExpired))
  );

  const handleEditTrainer = (client) => {
    setEditingClient(client);
    setTrainerName(client.trainerName);
  };

  const handleTrainerUpdate = async () => {

    try {
      const response = await axios.post(`https://klimkaara-backend-pgnq.onrender.com/clients/changetrainer/${editingClient.clientId}`, { name : trainerName });
      if(response.status === 200) {
       // Update the client with the selected trainer
       const updatedClients = clients.map(client =>
        client.name === editingClient.name ? { ...client, trainerName: trainerName } : client
      );
      setClients(updatedClients);
      // You would normally set state for clients here
      // e.g., setClients(updatedClients);
      setEditingClient(null); // Close the edit dropdown
      toast.success("Trainer updated successfully");
      closeModal();
      }
    } catch (error) {
      console.log(error);
    }
    
  };

  const closeModal = () => {
    setEditingClient(null); // Close the modal
  };

  // Handle Escape key press
  const handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      closeModal();
    }
  };

  const fetchClients = async () => {
    try {
      const response = await axios.get('https://klimkaara-backend-pgnq.onrender.com/clients/getPtClients');
      setClients(response.data.clientsWithTrainerNames);
      setTrainers(response.data.trainers);
    } catch (error) {
      console.error('Error fetching clients:', error);
    }
  };

  // Close modal when clicking outside
  useEffect(() => {

    fetchClients();
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        closeModal();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <div className="container mx-auto p-8 min-h-screen">
      <h1 className="text-3xl font-bold mb-6">Personal Training Clients</h1>
      
      {/* Dropdown Filters */}
      <div className="flex justify-between mb-4">
        <select
          value={plan}
          onChange={(e) => setPlan(e.target.value === "All" ? e.target.value : parseInt(e.target.value))}
          className="md:w-1/4 p-2 rounded-lg bg-gray-800 text-white"
        >
        <option value="All">All Plans</option>
          <option value="1">1 Month</option>
          <option value="3">3 Month</option>
          <option value="6">6 Month</option>
          <option value="12">1 Year</option>
        </select>

        <select
          value={sortOption}
          onChange={(e) => setSortOption(e.target.value)}
          className="w-1/2 md:w-1/4 p-2 rounded-lg bg-gray-800 text-white"
        >
          <option value="All">All</option>
          <option value="Expired">Expired</option>
        </select>
      </div>

      {/* Clients Table */}
      {filteredClients.length === 0 ? (
        <p className="text-center text-gray-400">No Clients Found</p>
      ) : (
        <table className="min-w-full bg-gray-800 text-white rounded-lg shadow-lg">
          <thead>
            <tr className="text-left border-b-2 border-gray-600">
              <th className="py-2 px-4">Name</th>
              <th className="py-2 px-4">Personal Trainer</th>
              <th className="py-2 px-4">Joined Date</th>
              <th className="py-2 px-4">Type of Plan</th>
              <th className="py-2 px-4">Plan Expired</th>
              <th className="py-2 px-4"></th>
            </tr>
          </thead>
          <tbody>
            {filteredClients.map((client, index) => (
              <tr key={index} className="border-b border-gray-700">
                <td className="py-2 px-4">{client.name}</td>
                <td className="py-2 px-4">{client.trainerName}</td>
                <td className="py-2 px-4">{new Intl.DateTimeFormat('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date(client.start))}</td>
                <td className="py-2 px-4">{client.plan} Months</td>
                <td className="py-2 px-4">
                  <span
                    className={`px-3 py-1 rounded-full text-white font-semibold ${
                      client.planExpired ? 'bg-green-600' : 'bg-red-600'
                    }`}
                  >
                    {client.planExpired ? 'Yes' : 'No'}
                  </span>
                </td>
                <td className="py-2 px-4">
                  <div className="relative inline-block text-left">
                    <button
                      onClick={() => handleEditTrainer(client)}
                      className="text-gray-400 hover:text-white"
                    >
                     <BsThreeDotsVertical />
                    </button>
                    {editingClient === client && (
                      <div className="absolute right-0 z-10 mt-2 w-48 rounded-md shadow-lg bg-gray-800">
                        <div className="py-1" role="menu" aria-orientation="vertical">
                          <button
                            onClick={handleTrainerUpdate}
                            className="block px-4 py-2 text-sm text-gray-200 hover:bg-gray-700 w-full text-left"
                            role="menuitem"
                          >
                            Edit Trainer
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      
      {/* Popup for selecting a trainer (this could be a modal) */}
      {editingClient && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
          <div ref={modalRef} className="flex flex-col justify-between bg-gray-900 p-8 rounded-lg shadow-lg w-80 h-64">
            <h2 className="text-lg font-bold mb-4">Select a New Trainer</h2>
            <select
              value={trainerName}
              onChange={(e) => setTrainerName(e.target.value)}
              className="w-full p-2 rounded-lg bg-gray-800 text-white mb-4"
            >
              <option value="">Select a trainer</option>
              {trainers.map((trainer, index) => (
                <option key={index} value={trainer.name}>{trainer.name}</option>
              ))}
            </select>
            <div className="flex justify-end">
              <button 
                onClick={closeModal} 
                className="mr-4 bg-red-600 text-white px-4 py-2 rounded-lg"
              >
                Cancel
              </button>
              <button 
                onClick={handleTrainerUpdate} 
                className="bg-green-600 text-white px-4 py-2 rounded-lg"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PTClients;
